<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <v-layout column justify-end fill-height>
      <div style="overflow-y: scroll;">
        <OpportunityRequirementsGuide v-if="eligibility && eligibility.requirementGroups"
          :requirementGroups="eligibility.requirementGroups" :opportunity="opportunity"
          :askSupport="!isEligible && !willOpportunityOpen" class="pb-2" />
        <v-divider />
      </div>

      <div class="pt-4">
        <v-layout row class="pb-1">
          <ProfileEligibilityIcon :opportunity="opportunity" @click="$emit('click')" :progress="progress"
            :color="color" />
          <QualificationEligibilityIcon :opportunity="opportunity" @click="$emit('click')" :progress="progress"
            :color="color" />
          <ExperienceEligibilityIcon :opportunity="opportunity" @click="$emit('click')" :progress="progress"
            :color="color" />
          <v-spacer />
          <ApplyButton v-if="!application" :opportunity="opportunity" :disabled="progress < 100" />
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
// Mixins
import { OpportunityDates } from '@/mixins/OpportunityDates.js'

import ExperienceEligibilityIcon from '@/components/candidate/applications/ExperienceEligibilityIcon'
import OpportunityRequirementsGuide from '@/components/guest/opportunities/OpportunityRequirementsGuide'
import ProfileEligibilityIcon from '@/components/candidate/applications/ProfileEligibilityIcon'
import QualificationEligibilityIcon from '@/components/candidate/applications/QualificationEligibilityIcon'
import ApplyButton from '@/components/candidate/applications/ApplyButton'

export default {
  mixins: [OpportunityDates],

  components: {
    ApplyButton,
    ExperienceEligibilityIcon,
    OpportunityRequirementsGuide,
    ProfileEligibilityIcon,
    QualificationEligibilityIcon,
  },

  props: {
    color: String,
    opportunity: { type: Object, required: true },
    progress: { type: Number, default: 0 },
  },

  computed: {
    application() {
      return this.$store.getters['candidate/applications/forOpportunity'](this.opportunity.id)
    },

    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },

    isEligible() {
      return this.eligibility && this.eligibility.eligible
    },
  },
}
</script>
